var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 254.88,
    height: 93.965,
    viewBox: "0 0 254.88 93.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gluedin_text_logo",
    "data-name": "gluedin text logo",
    transform: "translate(1389 58.84)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 9.345,
    height: 55.725,
    transform: "translate(-1342.473 -58.287)",
    fill: "#03f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M48.94,151.565V131.4h9.345v20.165c0,7.377,3.922,10.906,9.812,10.906s9.812-3.529,9.812-10.906V131.4h9.345v20.165c0,12.948-7.7,19.624-19.145,19.624-11.472,0-19.169-6.591-19.169-19.624",
    transform: "translate(-1377.764 -172.731)",
    fill: "#03f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M114.931,146.813c-1.488-5.177-5.73-7.771-10.833-7.771-5.263,0-9.345,2.668-10.833,7.771ZM83.22,150.981c0-11.767,8.632-20.411,20.878-20.411s20.718,8.632,20.718,20.411v3.3H93.032c1.254,5.656,5.57,8.632,11.066,8.632,4.156,0,7.218-1.18,9.185-3.689h9.972c-2.9,7.377-9.972,12.161-19.157,12.161-12.247,0-20.878-8.632-20.878-20.4",
    transform: "translate(-1369.894 -172.921)",
    fill: "#03f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M152.4,153.954c0-6.824-4.549-11.693-11.386-11.693s-11.46,4.869-11.46,11.693,4.636,11.693,11.46,11.693,11.386-4.869,11.386-11.693m-32.264-.393c0-13.267,9.886-20.018,19.3-20.018,5.57,0,10.206,2.361,12.948,6.677v-22.6h9.345v36.027c0,12.554-8.472,20.718-20.645,20.718-12.308-.012-20.952-8.484-20.952-20.8",
    transform: "translate(-1361.418 -175.894)",
    fill: "#03f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M165.248,134.669h9.345v38.769h-9.345Zm-1.488-11.226a6.2,6.2,0,1,1,12.394,0,6.2,6.2,0,1,1-12.394,0",
    transform: "translate(-1351.404 -176)",
    fill: "#03f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M176.142,150.194c0-12.947,7.7-19.624,19.157-19.624s19.145,6.591,19.145,19.624v20.177H205.1V150.194c0-7.377-3.922-10.906-9.812-10.906s-9.812,3.529-9.812,10.906v20.177H176.13V150.194Z",
    transform: "translate(-1348.564 -172.921)",
    fill: "#03f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M21.087,162.545a11.552,11.552,0,1,1,11.546-11.558,11.56,11.56,0,0,1-11.546,11.558m0-32.645a21.087,21.087,0,1,0,21.087,21.087A21.09,21.09,0,0,0,21.087,129.9",
    transform: "translate(-1389 -173.075)",
    fill: "#03f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M11.658,177.228l.086-.086a11.555,11.555,0,1,1,16.341,16.341.7.7,0,0,1-.1.086l6.75,6.75a.331.331,0,0,1,.1-.086A21.093,21.093,0,1,0,5.006,170.4a.57.57,0,0,0-.086.086Z",
    transform: "translate(-1387.87 -165.195)",
    fill: "#03f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/Brand.14dd61ab825a71681603a13827aeb246.svg";
export { ForwardRef as ReactComponent };